import * as React from 'react';

import { FieldTitle as RadixUIFieldTitle } from '@/components/ui/field';
import { cn } from '@/lib/utils';

type DiscoveryFieldTitleProps = React.ComponentPropsWithoutRef<typeof RadixUIFieldTitle>;

const DiscoveryFieldTitle = React.forwardRef<HTMLHeadingElement, DiscoveryFieldTitleProps>(
  ({ className, ...props }, ref) => (
    <RadixUIFieldTitle
      ref={ref}
      as="h3"
      className={cn('font-bold text-base text-left mb-4.5 md:text-lg', className)}
      {...props}
    />
  )
);
DiscoveryFieldTitle.displayName = 'DiscoveryFieldTitle';

export { DiscoveryFieldTitle };
